import React from 'react'

type State = { hasError: boolean; err?: any }
type Props = { children: React.ReactNode }

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, err: null }
  }

  static getDerivedStateFromError(err: any): State {
    return { hasError: true, err }
  }

  componentDidCatch(err: any, info: any) {
    console.error('ReactErrorBoundary:', err, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
          <h1>Something went wrong</h1>
          <pre style={{ whiteSpace: 'pre-wrap' }}>{String(this.state.err?.message || this.state.err)}</pre>
        </div>
      )
    }

    return this.props.children
  }
}

